import {useSelector} from "react-redux";
import './index.css'
import PlayGameMobile from "./mobile/index-mobile";
import PlayGameWeb from "./web/index-web";

const Stream = () => {
    const {agent} = useSelector(state => state.globalReducer)

    return (
        agent.isMobile ? <PlayGameMobile/> : <PlayGameWeb/>
    )


}

export default Stream
